import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.svg?react"; 

export default function Footer() {
   return (
      <div className="main-footer">
	   
         <span> <Logo style={{ width: "42px", height: "42px" }} /> &copy; 2001-{new Date().getFullYear()}. Rekonsil. All Rights Reserved.</span>
         <span>
            Powered <small>by</small>{" "} 
            <Link
               to="https://breadcrumbtechnology.com"
               target="_blank">
               Breadcrumb Technologies
            </Link>
         </span>
      </div>
   );
}
